import ReactSelect from '@common/ReactSelect';
import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux';
import { ADD_ONS_TYPE, APP_TYPE_AGENCY, APP_TYPE_RENEWAL, COUNTRY_CODE,ADDON_TANGGUNG,VEHICLE_TYPE_MOTORCYCLE,VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL,INS_TYPE_COMPREHENSIVE,WITH_RULE_ENGINE_ID } from 'config/constant';
import * as HELPER from "../../../config/helper";
import { getAddonList, getAddonListID } from '../create/FunctionList'
import { toast } from 'react-toastify';
import { useLanguage } from '@src/context/LanguageContext';


const AddonForm = (props: any) => {
    const commonState = useSelector((state: any) => state.common);
    const [value, setValue] = useState(3);
    const [addonCount, setAddonCount] = useState<number>(0);
    // Validate input field of allow two decimal value 
    const regex = /^[0-9]+(\.[0-9]{0,2})?$/;
    const [popupAddons, setPopupAddons] = useState<any>([]);
    const {premiumAmountState, setPremiumAmountState} = props
    const {isAddonEdit, setIsAddonEdit} = props

    const {translations} = useLanguage()

    /* ---------- ID multi-year: year tabs, Year 1 = full catalogue, later years = subset of Year 1 ---------- */
    const tenure = Math.max(1, Number(props?.tenure) || 1)
    const isYearWise = COUNTRY_CODE === 'id' && tenure > 1
    const [modalYear, setModalYear] = useState<number>(1)
    const [yearSelections, setYearSelections] = useState<Record<number, number[]>>({})

    const getYear1Ids = (addons: any = popupAddons): number[] =>
        (getAddonListID([...(addons?.basic || []), ...(addons?.special || [])]) || []).map((a: any) => +a.id)

    const initYearSelections = (addons: any) => {
        const year1 = getYear1Ids(addons)
        const next: Record<number, number[]> = { 1: year1 }
        for (let year = 2; year <= tenure; year++) {
            const source = props?.yearAddonSelections?.[year] ?? year1
            next[year] = source.map((id: any) => +id).filter((id: number) => year1.includes(id))
        }
        setYearSelections(next)
    }

    // re-open => start from the calculator's current selection on the requested year
    useEffect(() => {
        if (props?.show && isYearWise) {
            setModalYear(props?.initialYear && props.initialYear <= tenure ? props.initialYear : 1)
            initYearSelections(popupAddons)
        }
        // eslint-disable-next-line
    }, [props?.show, props?.initialYear, tenure])

    // Year 1 change: deselect cascades to every later year, a new pick is carried forward to later years
    const syncYear1Change = (addonId: number, selected: boolean) => {
        if (!isYearWise) return
        setYearSelections((prev: Record<number, number[]>) => {
            const next: Record<number, number[]> = { ...prev }
            for (let year = 1; year <= tenure; year++) {
                const list = (next[year] || []).filter((id: number) => id !== +addonId)
                next[year] = selected ? [...list, +addonId] : list
            }
            return next
        })
    }

    const toggleLaterYearAddon = (addonId: number) => {
        setYearSelections((prev: Record<number, number[]>) => {
            const list = prev[modalYear] || []
            return { ...prev, [modalYear]: list.includes(+addonId) ? list.filter((id: number) => id !== +addonId) : [...list, +addonId] }
        })
        setIsAddonEdit(true)
    }

    const hasAmount = (v: any) => v !== null && v !== undefined && v !== ''

    // premium of one addon for one policy year, taken from the latest calculation when available
    const getYearPremium = (item: any, year: number) => {
        if (!isRuleEngine()) return +(getPremiumAmount(item) || 0)
        const row = (props?.yearRows || []).find((r: any) => +r.tenure === year)
        const fromCalc = row?.addon_list?.find((a: any) => +a.id === +item.id)?.premium_amount
        if (hasAmount(fromCalc)) return +fromCalc
        const saved = (props?.addonDetailAll || []).find((a: any) => +a.id === +item.id && +a.tenure === year)?.premium_amount
        if (hasAmount(saved) && !isAddonEdit) return +saved
        // estimate the same way the pricing engine does: rate x depreciated TSI of that year
        const baseFmv = +(props?.insuranceState?.total_fmv || 0)
        const depRate = hasAmount(row?.dep_rate) ? +row.dep_rate : (hasAmount(row?.total_fmv) && baseFmv ? (+row.total_fmv / baseFmv) * 100 : (year === 1 ? 100 : null))
        if (item?.coverage_list?.length) {
            const option = item.coverage_list.find((o: any) => o.value === item?.coverage_amt)
            const total = (item?.id === ADDON_TANGGUNG) ? option?.alt_premium_amount : option?.premium_amount
            return hasAmount(total) ? Math.round(+total / tenure) : 0
        }
        if (item?.rate && depRate !== null) return Math.round(+item.rate * (baseFmv * depRate / 100) / 100)
        return 0
    }

    const getYearTotals = (year: number) => {
        const allItems = [...(popupAddons?.basic || []), ...(popupAddons?.special || [])]
        const ids = year === 1 ? getYear1Ids() : (yearSelections[year] || [])
        const items = allItems.filter((a: any) => ids.includes(+a.id))
        return { count: items.length, amount: items.reduce((sum: number, a: any) => sum + getYearPremium(a, year), 0) }
    }

    useEffect(() => {
        if (props && props?.addonCount) {
            setAddonCount(props?.addonCount);
        }
        // eslint-disable-next-line
    }, [props?.addonCount]);


    const onChangeCheckbox = (addonItem: any, event: any) => {


        updatePrimiumAmount('onChangeCheckbox');

        if (addonItem.is_required && addonItem.is_selected) {
            return false;
        } else {
            let count = addonCount;
            count = (event.target.checked) ? count + 1 : count - 1;
            setAddonCount(count)
        }
        if (addonItem.is_required) {
            addonItem.is_selected = true
        } else {
            addonItem['is_selected'] = !addonItem.is_selected
        }
        syncYear1Change(addonItem.id, !!addonItem.is_selected)
        if (COUNTRY_CODE !== 'id' && (props.insuranceState?.insurance_type_id === INS_TYPE_COMPREHENSIVE) && isRuleEngine() && addonItem.type === 'bi') {
            const oppositeAddon = popupAddons?.find((item: any) => item.type === 'pd');
            if (oppositeAddon) {
                if (oppositeAddon.is_required) {
                    oppositeAddon.is_selected = true
                } else {
                    oppositeAddon['is_selected'] = !oppositeAddon.is_selected
                }
            }
        }
        setValue(value + 1)
        setIsAddonEdit(true);
    }

    const onValueSelect = (addonItem: any, event: any) => {
        addonItem['coverage_amt'] = event.value
        addonItem['coverage_amount'] = event.value
        addonItem['premium_amount'] = (event.premium_amount && isRuleEngine() && COUNTRY_CODE !== 'id') ? event.premium_amount : addonItem.premium_amount
        if (COUNTRY_CODE !== 'id' && (props.insuranceState?.insurance_type_id === INS_TYPE_COMPREHENSIVE) && isRuleEngine() && addonItem.type === 'bi') {
            const oppositeAddon = popupAddons?.find((item: any) => item.type === 'pd');
            if (oppositeAddon) {
                oppositeAddon.coverage_amt = event.value;
            }
        }
        setValue(value + 1)
    }

    const onChangePremiumAmount = (addonItem: any, text: any) => {
        // validate two decimal digit value
        if (regex.test(text) || text === '') {
            let isComprensive = props.insuranceState?.insurance_type_id === 1 ? true : false;
           
            setPremiumAmountState((prev:any) => ({
                ...prev,
                [addonItem.id]: text
            }));
            if (!isComprensive && isRuleEngine())
                addonItem.coverage_amt = text ? text : ''
            else
                addonItem.premium_amount = text ? text : ''

            setValue(value + 1)

            updatePrimiumAmount('onChangePremiumAmount');

            setIsAddonEdit(true);
        
        }
    }


    const showHideAddons = async (action: any) => {
        updatePrimiumAmount('showHideAddons');
        let { checkValue, message }: any = (COUNTRY_CODE === 'id') ? await isValidAddonID() : await isValidAddon();
        if (checkValue) {
            props.setAddon(popupAddons, isYearWise ? yearSelections : undefined);
            props.showHideAddons(action);
        } else {
            for (let msg of message) {
                toast.error(msg);
            }
        }
        setIsAddonEdit(true);

    }

    const isValidAddonID = () => {
        let flag = true;
        let message: any = [];
        let addonList: any = getAddonListID([...(popupAddons?.basic?.concat(popupAddons?.special) || [])])

        for (let addon of addonList) {
            if (addon.is_required && !addon.premium_amount) {
                message.push(`Please select premium amount for ${addon.name} `);
                flag = false
            }
        }

        return new Promise((resolve) => resolve({ checkValue: flag, message }));
    }

    const isValidAddon = async () => {
        let flag = true;
        let message: any = [];
        // let addonList: any = getAddonList([], props.addonList);
        let addonList: any = getAddonList([], popupAddons);
        if (!addonList?.length) {
            //SKIP IF NO ADDON SELECTED
            // message.push("Please select addons");
            // flag = false
        } else {
            for (let data of addonList) {
                if (data.id === 1) {
                    if (!data["coverage_amount"]) {
                        message.push("Please select coverge amount for Bodily Injured");
                        flag = false
                    }
                    if (!data["premium_amount"]) {
                        message.push("Please Enter Premium amount for Bodily Injured");
                        flag = false
                    }
                } else if (data.id === 2) {
                    if (!data["coverage_amount"]) {
                        message.push("Please select coverge amount for Property Damage");
                        flag = false
                    }
                    if (!data["premium_amount"]) {
                        message.push("Please Enter Premium amount for Property Damage");
                        flag = false
                    }
                } else if (data.id === 3) {
                    if (!data["coverage_amount"]) {
                        message.push("Please select coverge amount for Personal Accident");
                        flag = false
                    } else if (!data["seat_capacity"]) {
                        message.push("Please select seat capacity for Personal Accident");
                        flag = false
                    }

                    // if(applicationType===2 && !data["premium_amount"]){
                    //     message.push("Please Enter Premium amount for Personal Accident");
                    //     flag = false
                    // }

                    if ((!data["premium_amount"] && (isNaN(data["premium_amount"]) && props?.insuranceState?.application_type_id === APP_TYPE_AGENCY)) && ['oona', 'milestone'].includes(props?.insuranceState?.partner_slug)) {
                        let premiumAmtValidation = true;
                        if (data['milestone_coverage_amount_limit'] || data['oona_coverage_amount_limit']) {
                            if (data['milestone_coverage_amount_limit'] === data['coverage_amount'] || data['oona_coverage_amount_limit'] === data['coverage_amount']) {
                                premiumAmtValidation = false;
                            }
                        }
                        if (premiumAmtValidation || props?.insuranceState?.rule_engine_id === 2) {

                            message.push("Please Enter Premium amount for Personal Accident");
                            flag = false
                        }
                    }

                }
            }

        }

        return new Promise((resolve) => resolve({ checkValue: flag, message }));
    }

    const calculateTotalPremiumValue = () => {
        let total = 0
        let filterList = null
        if (COUNTRY_CODE === 'id') {
            filterList = getAddonListID(popupAddons?.basic?.concat(popupAddons?.special))
        } else {
            filterList = props.addonList?.filter((item: any) => item?.is_selected)
        }
        if (filterList?.length) {
            filterList?.forEach((item: any) => {
                let premiumAmount = getPremiumAmount(item)
                if (ADD_ONS_TYPE.ACTS_OF_NATURE !== item.type)
                    if (premiumAmount)
                        total += parseFloat(premiumAmount ?? '0')
            })
        }
        if(COUNTRY_CODE === 'id'){
            props.setTotalAddonPremiumAmt(HELPER.addCurrencyFormatting( isAddonEdit === false? props.insuranceState?.total_addons_premium : total));     
        }
        return HELPER.addCurrencyFormatting(total)
    }

    const getPremiumAmount = (item: any) => {
        if (COUNTRY_CODE === 'id') {
            //for without Rule engine
            if (!isRuleEngine()) {
                const addon = props?.insuranceState?.addon_detail?.find(
                    (addonItem: any) => addonItem.id === item.id
                );

                if (premiumAmountState[item.id] !== undefined) {
                    return premiumAmountState[item.id];
                }
                
                if (addon?.premium_amount) {
                    return addon.premium_amount;
                }
               
            }
            if (item?.coverage_list?.length) {
                let filterItem = item?.coverage_list?.filter((option: any) => option.value === item?.coverage_amt)?.[0]
                if (!isRuleEngine()) {
                    return filterItem.premium_amount = 0;
                } else {
                    return (item?.id === ADDON_TANGGUNG) ? filterItem?.alt_premium_amount : filterItem?.premium_amount || 0
                }
                //return filterItem.premium_amount =0;       
                
            } else {
                if(!isRuleEngine()){
                    return item.premium_amount = 0;
                }
                return item.premium_amount || (item.rate * props?.insuranceState?.total_fmv)
            }
        }

        let isComprensive = props.insuranceState?.insurance_type_id === 1 ? true : false;
        if (isComprensive && isRuleEngine()) {
            if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type) {
                return item.premium_amount || ''
            }
            let filterItem = item?.coverage_list?.filter((option: any) => option.value === item.coverage_amt)?.[0]
            if (filterItem)
                return filterItem?.premium_amount || ''
            else
                return 0
        } else if (!isComprensive && !isRuleEngine()) {
            return item.premium_amount ? item.premium_amount : props?.insuranceState?.bi_amount
        }
        else {
            return item.premium_amount ? item.premium_amount : ''
        }
    }
    const getPremiumTitle = (item: any) => {
        if (COUNTRY_CODE === 'id') {
            if (isYearWise) return `Premium Amount (Yr ${modalYear}) : ${HELPER.addCurrencyFormatting(getYearPremium(item, modalYear))}`
            return item.category !== 'special' ? `Premium Amount : ${HELPER.addCurrencyFormatting(getPremiumAmount(item))}` : ''
        }

        let isComprensive = props.insuranceState?.insurance_type_id === 1 ? true : false;
        if (ADD_ONS_TYPE.PERSONAL_ACCIDENT === item.type && isComprensive && isRuleEngine()) {
            return ''
        }
        else if (ADD_ONS_TYPE.ACTS_OF_NATURE === item.type || ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL === item.type || ADD_ONS_TYPE.TOWING_ROWDSIDE === item.type) {
            return ''
        } else if (isComprensive && isRuleEngine()) {
            return `Premium Amount : ${HELPER.addCurrencyFormatting(getPremiumAmount(item))}`
        }
        return ''
    }
    const isRuleEngine = () => {
        if (props.insuranceState?.rule_engine_id === 1) return true
        else return false;
    }
  
    const isShowPremiumInputBox = (addonItem: any) => {
        let isComprensive = props.insuranceState?.insurance_type_id === 1 ? true : false;

        if (((!isComprensive && !isRuleEngine()) || (!isRuleEngine() && isComprensive)) && ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL !== addonItem.type && ADD_ONS_TYPE.TOWING_ROWDSIDE !== addonItem.type) {
            return true
        }
        else {
            if (addonItem.is_editable && !isRuleEngine()) { //ONLY IN CASE OF TRA WITHOUT RULE ENGINE
                if (ADD_ONS_TYPE.RIOTS_STRIKES_CIVIL === addonItem.type && props?.insuranceState?.partner_slug !== 'oona') return false

                return true
            } else {
                //FOR OONA & MERCENTILE IF COVERAGE AMT IS MATCHED FROM API THEN SHOW INPUT BOX
                if (addonItem.type === ADD_ONS_TYPE.PERSONAL_ACCIDENT && ['oona', 'milestone'].includes(props?.insuranceState?.partner_slug)) {
                    if (addonItem.coverage_amt === addonItem.oona_coverage_amount_limit || addonItem.coverage_amt === addonItem.milestone_coverage_amount_limit) {
                        addonItem.premium_amount = ''
                        return false
                    } else if ([VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(props?.insuranceState?.vehicle_type) && isComprensive && isRuleEngine()) {
                        return false
                    }
                    else{
                        return (addonItem.coverage_amt) ? true : false //MANUAL PREMIUM INPUT ALLOW 
                    }

                } else {
                    return false
                }
            }
        }
    }

    const saveExtraSeatingValue = (item: any, event: any) => {
        item.extra_seat_value = event.value
        setValue(value + 2)

    }

    const saveSeatingValue = (item: any, event: any) => {
        item.seat_capacity = event.value
        setValue(value + 3)
    };

    const updatePrimiumAmount = (from:string) => {
        if (!isRuleEngine() && COUNTRY_CODE === 'id') {
            
            const UpdatedPopAddons = { ...popupAddons };

            for(let existAddon of props?.insuranceState?.addon_detail ){
                const addon = props?.insuranceState?.addon_detail?.find(
                    (addon: any) => addon.id === existAddon.id
                );
                
                for (let basic of UpdatedPopAddons.basic) {
                    if(premiumAmountState[existAddon.id] && basic.id === existAddon.id){
                        basic.premium_amount = premiumAmountState[existAddon.id]
                    }
                    else if (!basic.premium_amount && basic.id === existAddon.id) {
                        basic.premium_amount = addon?.premium_amount
                    }
                }
    
                for (let special of UpdatedPopAddons.special) {
                    if(premiumAmountState[existAddon.id] && special.id === existAddon.id){
                        special.premium_amount = premiumAmountState[existAddon.id]
                    }
                    else if (!special.premium_amount && special.id === existAddon.id) {
                        special.premium_amount = addon?.premium_amount
                    }
                }
            }
            setPopupAddons(UpdatedPopAddons);
        }
    }

    useEffect(() => {
        let isValidAddonList = COUNTRY_CODE === 'id' ? Object.keys(props?.addonList)?.length : (props.addonList?.length)
       
        if (isValidAddonList) {
            let addonsData = JSON.parse(JSON.stringify(props.addonList))
            setPopupAddons(addonsData);
            if (isYearWise) initYearSelections(addonsData);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.addonList])

    const getFields: any = (item: any) => {
        const isVehicleTypeMotorCycle = [VEHICLE_TYPE_MOTORCYCLE, VEHICLE_TYPE_MOTORCYCLE_COMMERCIAL].includes(props?.insuranceState?.vehicle_type_id);
        const isComprensive = props.insuranceState?.insurance_type_id === INS_TYPE_COMPREHENSIVE ? true : false;
       
        
        let commonHTML: any = (
            <>
                <fieldset className="form-filed col-md-12 m-md">
                    <div className="material">
                        <div className="custom-control custom-checkbox">
                            {
                                (props?.insuranceState?.application_type_id === APP_TYPE_RENEWAL && item.type === 'pa' && props?.insuranceState?.parent_pa_exist) //disable PA if parent lead has PA selected 
                                    ?
                                    <>
                                        <input checked={item.is_selected} disabled={item.is_disabled} id="Individual" type="checkbox" className="custom-control-input " name="Buyer Type" />
                                        <label className="custom-control-label">{item.name}</label>
                                    </>
                                    :
                                    <>

                                        <input checked={item.is_selected} disabled={item.is_disabled} id="Individual" type="checkbox" className="custom-control-input " name="Buyer Type" onChange={(event) => {
                                            onChangeCheckbox(item, event)
                                        }} />
                                        <label className="custom-control-label">{item.name}</label>
                                    </>

                            }
                        </div>
                    </div>
                </fieldset>

                {
                    item.coverage_list?.length ?

                        <ReactSelect
                            // options={item.coverage_list || []} 
                            options={item.coverage_list.map((item: any) => ({
                                ...item,
                                label: (item.label && COUNTRY_CODE === 'id') ? HELPER.addCurrencyFormatting(item.label) : item.label,
                            }))}
                            value={item.coverage_amt ? { label: COUNTRY_CODE === 'id' ? HELPER.addCurrencyFormatting(item.coverage_amt) : item.coverage_amt, value: item.coverage_amt, premium_amount: '' } : null}
                            handleChange={(e: any) => onValueSelect(item, e)} placeholder="Choose Coverage Amount"
                            isDisabled={(COUNTRY_CODE !== 'id' && (props.insuranceType === 2 || isVehicleTypeMotorCycle) || item.is_disabled ) ? true : false}
                            fieldKey=""

                        />
                        : null

                }
            </>
        )
        if (COUNTRY_CODE === 'id') {
            return (
                <>
                    {commonHTML}
                    {
                        item?.seat_capacity_list?.length
                        &&
                        <ReactSelect
                            options={item.seat_capacity_list}
                            value={item.seat_capacity ? { label: item.seat_capacity, value: item.seat_capacity } : null}
                            handleChange={(e: any) => saveSeatingValue(item, e)} placeholder="Seating Capacity"
                            fieldKey=""
                            isDisabled={false}
                        />
                    }
                    
                    
                    {!isRuleEngine() ?

                        isShowPremiumInputBox(item) &&
                        <fieldset className="form-filed col-md-6">
                            <div className="material">
                                <input spellCheck="false" id="" type="text" placeholder=" " name="RoleName" className="form-input"
                                    value={HELPER.addCurrencyFormatting(getPremiumAmount(item))}  
                                    onChange={(event) => {
                                        const inputValue = event.target.value;
                                        const finalValue = HELPER.removeCurrencyFormattingId(inputValue)
                                        onChangePremiumAmount(item, finalValue);
                                    }} />
                                <label data-label="Premium Amount" className="form-label"></label>
                            </div>
                        </fieldset>

                        :
                        getPremiumTitle(item)?.length > 0 &&
                        <div className="material col-md-7 text-right premium-txt">
                            <span>{getPremiumTitle(item)}</span>
                        </div>
                    }
                </>
            )
        } else {
            return (
                <>
                    {commonHTML}
                    {
                        item.type === 'pa' &&
                        <>
                            <ReactSelect
                                options={commonState.common.seat_capacity}
                                value={item.seat_capacity ? { label: item.seat_capacity, value: +item.seat_capacity } : null}
                                handleChange={(e: any) => saveSeatingValue(item, e)} placeholder="Seating Capacity"
                                fieldKey=""
                                isDisabled={((props?.insuranceState?.application_type_id === APP_TYPE_RENEWAL && props?.insuranceState?.parent_pa_exist) || isVehicleTypeMotorCycle) ? true : false} //disable PA if parent lead has PA selected
                            />
                            {
                                 !isVehicleTypeMotorCycle
                                 && <ReactSelect
                                 options={commonState.common.seat_capacity}
                                 value={item?.extra_seat_value ? { label: item.extra_seat_value, value: item.extra_seat_value } : null}
 
                                 handleChange={(e: any) => saveExtraSeatingValue(item, e)}
 
                                 placeholder="Extra Seat Added"
                                 fieldKey=""
                                />
                            }
                            
                        </>

                    }
                    {
                        getPremiumTitle(item)?.length > 0 &&
                        <div className="material col-md-7 text-right premium-txt">
                            <span>{getPremiumTitle(item)}</span>
                        </div>
                    }
                    {
                        isShowPremiumInputBox(item) &&
                        <><fieldset className="form-filed col-md-6">
                            <div className="material">
                                <input id="" type="number" placeholder=" " name="RoleName" className="form-input" value={getPremiumAmount(item)} onChange={(event) => {
                                    onChangePremiumAmount(item, event.target.value);
                                }} />
                                <label data-label="Premium Amount" className="form-label"></label>
                            </div>
                        </fieldset>
                        {
                            COUNTRY_CODE === 'ph'  && !isRuleEngine() && item.type === 'pd' && 
                                <div className="note-text">
                                    <span><b>Note</b>: PD coverage amount should be same as BI coverage amount.</span>
                                </div>
                        }
                        </>
                    }
                    

                </>
            )
        }
    }
    

    const generateLaterYearList = () => {
        const year1 = getYear1Ids()
        const selected = yearSelections[modalYear] || []
        return ['basic', 'special'].map((category: string) => {
            const child = (popupAddons?.[category] || []).filter((item: any) => year1.includes(+item.id))
            if (!child.length) return null
            const h2 = category[0].toUpperCase() + category.slice(1)
            return (
                <React.Fragment key={`later-${category}`}>
                    <div className='m-lg-t'>
                        <h2>{translations?.Insurance?.[h2] || translations?.commonMsg?.loading}</h2>
                    </div>
                    {child.map((item: any) => (
                        <div key={`later-${item.id}`} className="row AddonSection m-md-t quote-detail-form quote-details-form-premium-amt">
                            <fieldset className="form-filed col-md-12 m-md">
                                <div className="material">
                                    <div className="custom-control custom-checkbox">
                                        <input checked={selected.includes(+item.id)} id={`addon-y${modalYear}-${item.id}`} type="checkbox" className="custom-control-input" onChange={() => toggleLaterYearAddon(item.id)} />
                                        <label className="custom-control-label" htmlFor={`addon-y${modalYear}-${item.id}`}>{item.name}</label>
                                    </div>
                                </div>
                            </fieldset>
                            <div className="material col-md-7 text-right premium-txt">
                                <span>{`Premium Amount (Yr ${modalYear}) : ${HELPER.addCurrencyFormatting(getYearPremium(item, modalYear))}`}</span>
                            </div>
                        </div>
                    ))}
                </React.Fragment>
            )
        })
    }

    const renderYearTabs = () => (
        <>
            <ul className="addon-year-tabs">
                {Array.from({ length: tenure }, (_, i) => i + 1).map((year: number) => (
                    <li key={year} className={`addon-year-tab ${year === modalYear ? 'active' : ''}`} onClick={() => { updatePrimiumAmount('yearTab'); setModalYear(year) }}>
                        {translations?.Insurance?.['Year'] || 'Year'} {year}
                    </li>
                ))}
            </ul>
            {modalYear > 1 && (
                <div className="addon-lock-banner">
                    <svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2" /><path d="M8 11V7a4 4 0 0 1 8 0v4" /></svg>
                    <span>{translations?.Insurance?.['Only add-ons selected in Year 1 are shown here. Add-ons not chosen in Year 1 can\'t be added in later years.'] || "Only add-ons selected in Year 1 are shown here. Add-ons not chosen in Year 1 can't be added in later years."}</span>
                </div>
            )}
        </>
    )

    const generateAddonList = () => {
        const addonListing = COUNTRY_CODE === 'id' ? (Object.keys(popupAddons)?.length ? Object.keys(popupAddons) : undefined) : (popupAddons?.length ? popupAddons : undefined)

        return addonListing?.map((addon: any) => {
            if (COUNTRY_CODE === 'id') {
                const child = popupAddons?.[addon] || []
                const h2 = child.length? addon?.[0].toUpperCase() + addon?.slice(1) : ''
                

                return (
                    <React.Fragment key={addon}>
                        <div className='m-lg-t'>
                            <h2>{h2!==''?translations?.Insurance?.[h2] || translations?.commonMsg?.loading:''}</h2>
                        </div>
                        {
                            child?.map((item: any) => {
                                return (
                                    <React.Fragment key={item.type}>
                                        <div className={"row AddonSection m-md-t quote-detail-form " + (item?.coverage_list?.length ? '' : 'quote-details-form-premium-amt')}>

                                            {
                                                getFields(item)
                                            }
                                        </div>
                                    </React.Fragment>
                                )
                            })
                        }
                    </React.Fragment>
                )
            }

            return (
                <React.Fragment>
                    <div className="row AddonSection m-md-t quote-detail-form">
                        {
                            getFields(addon)
                        }
                    </div>
                </React.Fragment>
            )
        }) || (<></>)
    }

    return (
        <React.Fragment>
            <div className="modal-header">
                <h2>{translations?.Insurance?.['Add Ons Selection'] || translations?.commonMsg?.loading}</h2>
            </div>
            <div className="modal-body" key={'addon-body'}>
                <div className="form-group-bx">
                    {isYearWise && renderYearTabs()}
                    {
                        (isYearWise && modalYear > 1) ? generateLaterYearList() : generateAddonList()
                    }

                </div>
            </div>
            <div className="modal-footer ">
                <div className="material addonwrapper p-md-b">
                    <div className="">
                        {
                            (isYearWise && modalYear > 1)
                                ? <><p>{getYearTotals(modalYear).count} {translations?.Insurance?.['Add Ons'] || 'Add Ons'}</p> <p className='black'><label>{HELPER.addCurrencyFormatting(getYearTotals(modalYear).amount)}</label></p></>
                                : isYearWise
                                    ? <><p>{addonCount} {translations?.Insurance?.['Add Ons'] || 'Add Ons'}</p> <p className='black'><label>{(calculateTotalPremiumValue(), HELPER.addCurrencyFormatting(getYearTotals(1).amount))}</label></p></>
                                    : <><p>{addonCount} {translations?.Insurance?.['Add Ons'] || 'Add Ons'}</p> <p className='black'>       <label>{calculateTotalPremiumValue()}</label> </p></>
                        }
                    </div>
                    <button className="btn-primary" onClick={() => showHideAddons(this)} >{translations?.Insurance?.['Apply'] || translations?.commonMsg?.loading}</button>
                </div>

            </div>
        </React.Fragment>
    )
}

export default AddonForm